import { render } from "./HireUs.vue?vue&type=template&id=1be566be&scoped=true"
import script from "./HireUs.vue?vue&type=script&lang=js"
export * from "./HireUs.vue?vue&type=script&lang=js"

import "./HireUs.vue?vue&type=style&index=0&id=1be566be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be566be"]])

export default __exports__